<template>
    <page>
        <module :title="id ? '编辑秒杀活动' : '新建秒杀活动'">
            <c-form ref="form">
                <c-form title="基础信息">
                    <c-form-item type="hidden" name="activity_id" v-model="activity_id" required></c-form-item>
                    <!--默认与其他活动互斥-->
                    <c-form-item type="hidden" name="activity_mutex_flag" value="1"></c-form-item>
                    <!--默认【独立库存】-->
                    <c-form-item type="hidden" name="ind_activity_stock" value="1"></c-form-item>
                    <c-form-item type="input" label="活动名称"  name="activity_name" maxlength="20" required></c-form-item>
                    <c-form-item type="datetime" label="活动时间" start-name="begin_date" end-name="end_date" required></c-form-item>
                    <c-form-item type="radio" label="活动预告设置" value="-1"  name="activity_notice" v-model="activityNotice" :options="activityNoticeOptions" required
                                 word="活动预告期间，商品详情页价格上方将会展示活动标题，开始时间和折扣力度。" ></c-form-item>
                    <c-form-item type="number" v-if="activityNotice == 1" decimal="1" :limit="[0.1,9999]" v-model="activityNoticeTime" name="activity_notice_time" required
                                 input-unit="时" word="活动开始前在商品详情页展示活动信息、活动价等"></c-form-item>
					<c-form-item type="radio" label="下单未支付时" name="auto_cancel" :options="cancelType" value="1" v-model="autoCancel" required></c-form-item>
					<c-form-item type="number" v-if="autoCancel == 1" name="cancel_time" label="" v-model="cancelTime"  decimal="0" :limit="[1,180]"
                                 required input-unit="分" word="秒杀活动商品下单后，超过该时间未支付，则订单自动取消"></c-form-item>
                    <c-form-item type="input" label="活动标签" name="tags" maxlength="4" word="标签最多输入4个字符；该标签将显示在商品列表、SKU弹窗中"></c-form-item>
                </c-form>

                <c-form title="活动商品">
                    <c-form-item>
                        <m-operate>
                            <c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>
                        </m-operate>

                        <c-table ref="productList" v-model="productList" height="auto" :paging="false" border>
                            <c-table-column
                                    type="selector"
                            ></c-table-column>

                          <c-table-column
                              label="商品信息"
                              name="product_name"
                              width="250"
                          >
                            <template v-slot="{data}">
                              <div class="flex-center">
                                <c-image :src="oss(data.product_img_url, 46, 46)" size="46" preview></c-image>
                                <p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                                    <span v-if="data.product_itemnumber">{{data.product_itemnumber}} - </span>
                                    {{data.product_name}}
                                </p>
                              </div>
                            </template>
                          </c-table-column>

                          <c-table-column
                                    label="价格"
                                    name="product_price"
                                    width="130"
                            >
                                <template v-slot="{data}">￥{{data.product_price}}</template>
                          </c-table-column>

                          <c-table-column
                                    label="活动库存（单SKU）"
                                    name="activity_stock_count"
                                    width="130"
                            >
                            <template v-slot="{data}">
                              <c-input  v-model="data.activity_stock_count" width="80" type="number" :limit="[1, 999]"></c-input>
                            </template>
                          </c-table-column>

                          <c-table-column
                              label="折扣"
                              width="100"
                          >
                            <template v-slot="{data}">
                              <c-input :disabled="setConfigType == 2" decimal="1" :limit="[0.1,10]" v-model="data.activity_discount" width="80" type="number" style="margin: 0 5px;" word="折"></c-input>
                            </template>
                          </c-table-column>

                          <c-table-column
                              label="促销价"
                              name="promotion_price"
                              width="140"
                          >
                            <template v-slot="{data}">
                              <span v-if="data.activity_discount" >
                                      ￥{{parseFloat(data.product_price_min * data.activity_discount / 10).toFixed(2)}}
                                      <span v-if="data.product_price_max">
                                          - ￥{{parseFloat(data.product_price_max * data.activity_discount / 10).toFixed(2)}}
                                      </span>
                                    </span>
                            </template>
                          </c-table-column>

                            <c-table-column
                                    label="商品启/禁用"
                                    name="state"
                                    width="80"
                            >
                                <template v-slot="row">
                                    <c-switch :value="row.data.state == 2" text="启用,禁用" @change="changeProductState(row, arguments[0], arguments[1])"></c-switch>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    type="button"
                                    fixed="right"
                                    label="操作"
                                    width="80"
                            >
                                <template v-slot="row">
                                    <c-table-button  @click="removeRow(row)">删除</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-form-item>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button  power="b_activity_presell_edit" size="m" @click="submit()">提交保存</c-button>
            </template>
        </module>
        <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
    import productSelector from '@/components/service/product_selector.vue'
    export default {
        name: 'activity_presell_edit',

        components: {
            productSelector
        },

        props: {
            id: String
        },

        data() {
            return {
                setConfigType:1,
                activityNoticeTime: 0,
                activityNotice: 0,
                activityNoticeOptions: [{
                  name: '立即预告',
                  value: 0
                },{
                  name: '不预告',
                  value: -1
                },{
                  name: '提前预告',
                  value: 1
                }],
                activity_id: '',
                productList: [],
				autoCancel: 1,
				cancelTime: 5,
				cancelType: [{
					name: '按指定时长自动取消',
					value: 1
				}, {
					name: '按系统配置自动取消',
					value: 0
				}]
            }
        },

        watch: {
            id() {
                this.getActivityDetail();
            },

            commodityRange(val) {
                if (val == 2) {
                    this.$refs.productList.resize();
                }
            }
        },

        mounted() {
            this.id && this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activitySecondkill/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.$refs.form.set(data);
                        this.activityNoticeTime = data.activity_notice_time;
						this.cancelTime = data.cancelTime;
                        this.productList = data.product_list;
                    }
                });
            },
            productSelectHandle(list) {
                list = list.filter(item => {
                    return !this.productList.find(row => {
                        return row.product_id == item.product_id;
                    });
                });
                this.productList = this.productList.concat(list);
            },
            submit() {
                this.$refs.form.submit({
                    url: this.id ? '/activitySecondkill/edit' : '/activitySecondkill/add',
                    rule: {
                        activity_name: '请填写活动名称',
                        begin_date: '请选择活动时间',
                        end_date: '请选择活动时间',
                        activity_notice: '请选择通知类型',
                        product_list: [{
                            type: 'function',
                            fun: () => {
                                return this.productList.length;
                            },
                            word: '请选择活动商品'
                        }],
                        activity_notice_config: [{
                          type: 'function',
                          fun: (val,data) => {
                            //指定商品且设置折扣时判断
                            if(this.activityNotice == 1 && (!data.activity_notice_time || data.activity_notice_time<=0)){
                              return false;
                            }else return true;
                          },
                          word: '请填写提前预告时间'
                        }],
                        auto_cancel_config: [{
                          type: 'function',
                          fun: (val,data) => {
                            //自动取消时长时判断
                            if(this.autoCancel == 1 && (!data.cancel_time || data.cancel_time<=0)){
                              return false;
                            }else return true;
                          },
                          word: '请填写自动取消时长'
                        }],
                        product_config: [{
                            type: 'function',
                            fun: () => {
                              //必须填写活动库存
                              return !this.productList.find(item => {
                                return !item.activity_stock_count;
                              });
                            },
                            word: '请设置活动商品库存'
                        }],
                        discount_config: [{
                          type: 'function',
                          fun: () => {
                            //指定商品且设置折扣时判断
                            if(this.commodityRange == 1 && this.setConfigType == 1){
                              return !this.productList.find(item => {
                                return !item.activity_discount;
                              });
                            }else return true;
                          },
                          word: '请设置活动商品折扣'
                        }],
                    },

                    dataFormatter: data => {
                        this.id && (data.id = this.id);
                        data.product_list = Array.from(this.productList, item => {
                            return {
                                product_id: item.product_id,
                                activity_stock_count: item.activity_stock_count,
                                state: item.state,
                                activity_discount: item.activity_discount
                            }
                        });
                        return data;
                    },

                    success: (data,obj) => {
                        if(obj != null && obj.length !=0){
                            var res = "【";
                            obj.forEach(item=>{
                                res+=item+","
                            })
                            res = res.substring(0,res.length-1);
                            res+="】"

                            this.$message({
                                text: '保存成功,存在以下商品和其他活动时间冲突未能添加成功'+res.toString(),
                            });
                        }else{
                            this.$message({
                                text: "保存成功",
                            });
                        }

                        this.$bus.$emit('activitySecondkillList.update');
                        this.redirectTo('/activity_secondkill');
                    }
                })
            },
            /**
             * 删除行
             */
            removeRow(row) {
                this.$confirm({
                    text: '是否确定将商品【'+row.data.product_name+'】从当前活动中删除（提交保存后生效）？',
                    buttonName: '确定删除',
                    cancelButton: true,
                    resolve: () => {
                        row.remove();
                    }
                });
            },
            /**
             * 活动启禁用
             * @param state true = 启用(2)  false=禁用(1)
             */
            changeProductState(row,state, stop) {
                row.data.state = state?2:1;
            },
        }
    }
</script>

<style lang="stylus" scoped>
  .limit {
    .item {
      margin-right: 16px;

      label {
        margin-right: 8px;
      }
    }
  }
</style>